import { InfrontSDK } from "@infront/sdk";
import featureFlags from "@portal/helpers/featureFlag";

export type InfrontSDKSnapshot = {
  instance: InfrontSDK.SDK | null;
  isReady: boolean;
};

let sdkInstance: InfrontSDK.SDK | null = null;
let sdkReady = false;
const listeners = new Set<() => void>();

const notifyListeners = () => listeners.forEach(listener => listener());

const createInstance = (infrontAccessToken: string) => {
  const infrontSDK = new InfrontSDK.SDK({
    signedToken: infrontAccessToken,
    onReady: () => {
      sdkReady = true;
      notifyListeners();
    },
    onDisconnect: (event?: InfrontSDK.DisconnectEvent) => {
      console.warn("Disconnected:", event);
    },
  });

  return infrontSDK;
};

let snapshot: InfrontSDKSnapshot = { instance: null, isReady: false };

export const subscribeInfrontSDK = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const getInfrontSDKSnapshot = (): InfrontSDKSnapshot => {
  if (snapshot.instance !== sdkInstance || snapshot.isReady !== sdkReady) {
    snapshot = { instance: sdkInstance, isReady: sdkReady };
  }
  return snapshot;
};

export const getInfrontSDKServerSnapshot = (): InfrontSDKSnapshot => ({ instance: null, isReady: false });

export const initializeInfrontSDK = (infrontAccessToken: string) => {
  if (!featureFlags.isInfrontEnabled || sdkInstance) return sdkInstance;

  sdkInstance = createInstance(infrontAccessToken);
  notifyListeners();
  return sdkInstance;
};
